// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"OrgManagers_contentSection__3uU_J","content":"OrgManagers_content__Q9zhg","title":"OrgManagers_title__JkmdS","pagination":"OrgManagers_pagination__REs9s"};